import { useActivation } from '@context/MobileOne';
import { Feedback, ScrollToTop } from '@core/index';
import { appButtonType, appIconsPath } from '@utils/globalConstant';
import { tA11y } from '@utils/a11y/a11yHelpers';

export const EmailVerificationSuccess = () => {
  const { nextSubStep0 } = useActivation();

  // Const
  const headerContent = tA11y('ek_reg_mail-suc_hdl1');
  const copyTextContent = tA11y('ek_reg_mail-suc_txt1');
  const buttonContent = tA11y('ek_reg_mail-suc_btn1');

  return (
    <>
      <ScrollToTop>
        <Feedback
          icon='SENT'
          headingContent={headerContent}
          copyTextContent={copyTextContent}
          buttonContent={buttonContent}
          buttonType={appButtonType.PRIMARY}
          buttonIcon={appIconsPath.ARROW_RIGHT}
          buttonClick={() => nextSubStep0()}
        />
      </ScrollToTop>
    </>
  );
};

export default EmailVerificationSuccess;
